// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__zzZnX","modalForm":"UpgradeEpcsModal_modalForm__2c_xs","modalFooter":"UpgradeEpcsModal_modalFooter__3S4cs"};